<template>
    <section class="about-us-area">
        <div class="container">
            <div class="row align-items-center">
                <!--Why Choose Content and Image box Start-->
                <div class="col-12 col-sm-12 col-md-6">
                    <div class="about-us-content">
                        <h2 class="section-heading">{{ pageData.title }}</h2>
                        <p class="section-subheading" v-if="pageData.subheading">{{ pageData.subheading }}</p>
                        <div v-html="pageData.content"></div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6" v-if="pageData.image_name">
                    <div class="about-us-img aos-init aos-animate" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1000">
                        <img :src="filePath+'/'+pageData.image_name" :alt="pageData.title">
                    </div>
                </div>
                <!--Why Choose Content and Image box End-->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        pagedata: Object,
        filepath: String
    },
    data() {
        return {
            pageData: '',
            filePath: '',
        }
    },
    watch: {
        'pagedata'(){
            this.pageData = this.$props.pagedata
        },
        'filepath'(){
            this.filePath = this.$props.filepath
        }
    }
}
</script>